import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../Components/LanguageContext';
import handleTransformLang from '../functions/handleTransformLang';
import actionCardsContent from '../lang/components/dealershipActionCards.json';

const actionCards = [
  {
    image: '/images/buton3.png',
    mobileImage: '/images/action-cards-mobile/bayilik.png',
    to: '/dealership/application',
  },
  {
    image: '/images/buton2.png',
    mobileImage: '/images/action-cards-mobile/basvuru-sorgu.png',
    to: '/dealership/query',
  },
  {
    image: '/images/buton1.png',
    mobileImage: '/images/action-cards-mobile/b2b.png',
    to: 'https://b2b.bulutmarket.com.tr',
    external: true,
  },
];

export default function DealershipActionCards({
  className = '',
  itemClassName = 'flex justify-center',
  imageClassName = 'w-full max-w-[18.5rem] object-contain transition-transform duration-300 hover:scale-105',
  mobileImageClassName = 'w-full max-w-[21.5rem] object-contain min-[701px]:hidden',
}) {
  const { language } = useContext(LanguageContext);
  const [content, setContent] = useState(handleTransformLang(actionCardsContent));

  useEffect(() => {
    setContent(handleTransformLang(actionCardsContent));
  }, [language]);

  return (
    <div className={`grid gap-4 sm:grid-cols-2 lg:grid-cols-3 ${className}`}>
      {actionCards.map((card, index) => {
        const alt = content.items?.[index]?.alt || '';
        const image = (
          <>
            <img
              src={card.mobileImage}
              alt={alt}
              className={mobileImageClassName}
            />
            <img
              src={card.image}
              alt={alt}
              className={`hidden min-[701px]:block ${imageClassName}`}
            />
          </>
        );

        return (
          <div key={`${card.to}-${index}`} className={itemClassName}>
            {card.external ? (
              <a
                href={card.to}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex"
              >
                {image}
              </a>
            ) : (
              <Link to={card.to} className="inline-flex">
                {image}
              </Link>
            )}
          </div>
        );
      })}
    </div>
  );
}
